import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Paper, BorrowerCredits } from 'components';
import { jsx as ___EmotionJSX } from "@emotion/react";

var BorrowerCreditsTab = function BorrowerCreditsTab(_ref) {
  var idNumber = _ref.idNumber;
  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(Row, {
    justify: "space-between",
    align: "center",
    backgroundColor: "white"
  }, ___EmotionJSX(Col, {
    sm: 12
  }, ___EmotionJSX(Paper, {
    header: function header(_ref2) {
      var css = _ref2.css;
      return ___EmotionJSX("div", {
        css: css
      }, ___EmotionJSX("h5", null, "\u041A\u0440\u0435\u0434\u0438\u0442\u0438"));
    },
    margin: "0 0 2em 0"
  }, ___EmotionJSX(BorrowerCredits, {
    idNumber: idNumber
  })))));
};

BorrowerCreditsTab.propTypes = {
  idNumber: PropTypes.string
};
export default BorrowerCreditsTab;